<template>
  <div class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex justify-center items-center">
    <div class="relative bg-white rounded-lg shadow-xl">
      <button @click="close" class="absolute top-0 right-0 mt-4 mr-4 text-gray-400 hover:text-gray-600">
        <span class="text-2xl">&times;</span>
      </button>
      
      <div v-if="!selectedFormType" class="p-6">
        <h2 class="text-2xl font-bold mb-4">Patient: {{ selectedPatient?.givenName }} {{ selectedPatient?.surname }}</h2>
        <div class="space-y-4">
          <button @click="selectForm('Muster 16')" class="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600">
            Muster 16
          </button>
          <button @click="selectForm('Muster 15')" class="w-full bg-green-500 text-white p-2 rounded hover:bg-green-600">
            Muster 15
          </button>
          <button @click="selectForm('Muster 12')" class="w-full bg-yellow-500 text-white p-2 rounded hover:bg-yellow-600">
            Muster 12
          </button>
          <!-- ... other buttons ... -->
        </div>
      </div>
      <ERezept v-else
               :formType="selectedFormType"
               @save="handleSave" 
               @close="closeForm" />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useDbStore } from '../stores/dbStore';
import { useERezeptStore } from '../stores/eRezeptStore';
import ERezept from './ERezept.vue';

export default {
  name: 'MusterModal',
  components: {
    ERezept
  },
  setup() {
    const dbStore = useDbStore();
    const selectedPatient = computed(() => dbStore.getSelectedPatient);
    const selectedFormType = computed(() => dbStore.getSelectedFormType);

    const close = () => {
      dbStore.closeMusterModal();
    };

    const selectForm = (formType) => {
      const eRezeptStore = useERezeptStore();
      if (formType === 'Muster 15') {
        eRezeptStore.setActiveTab('Hörhilfenverordnung');
      } else if (formType === 'Muster 16') {
        eRezeptStore.setActiveTab('PZN-Verordnung');
      } else if (formType === 'Muster 12') {
        eRezeptStore.setActiveTab('Häusliche Krankenpflege');
      }
      
      dbStore.selectFormType(formType);
    };

    const closeForm = () => {
      dbStore.selectFormType(null);
    };

    const handleSave = (bundle) => {
      console.log('E-Rezept Bundle gespeichert:', bundle);
      close();
    };

    return {
      selectedPatient,
      selectedFormType,
      close,
      selectForm,
      closeForm,
      handleSave
    };
  }
}
</script>